export enum OfferTypes {
  General = 1,
  ConsumerSpecific = 2,
  BinSpecific = 4,
  ConsumerLimited = 8,
}
